import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState, type ReactNode } from 'react'
import { BetaBanner } from '@/components/shared/beta-banner'
import { AppToaster } from '@/components/theme/app-toaster'
import { ThemeProvider } from '@/components/theme/theme-provider'

export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
        },
      }),
  )
  return (
    <ThemeProvider defaultTheme="system" storageKey="ringout-theme">
      <QueryClientProvider client={queryClient}>
        <BetaBanner />
        {children}
        <AppToaster />
      </QueryClientProvider>
    </ThemeProvider>
  )
}
